import { render, staticRenderFns } from "./btAddFavoris.vue?vue&type=template&id=296a6170&"
import script from "./btAddFavoris.vue?vue&type=script&lang=js&"
export * from "./btAddFavoris.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports